import { requestTool } from "../tools";

const getLanguages = (url) => {
    return requestTool.getRequest(url + "/api/Language/GetAll");
}

export const languageService = { getLanguages };

export default languageService;
